import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import solutions from '@/view/solutions/solutions'
import solutionsDetail from '@/view/solutions/solutionsDetail'
import news from '@/view/news/news'
import newsDetail from '@/view/news/newsDetail'
import contact from '@/view/contact/contact'
import home from '@/view/home/home'
import about from '@/view/about/about'
import products from '@/view/products/products'
import products_xq from '@/view/products/products_xq'
import vrList from '@/view/vrList/vrList'
Vue.use(Router)

export default new Router({
//   mode:'history',
  routes: [
	{
		path: '/',
		name: 'home',
		component: home,
		meta: { title: 'home' }
	},
	{
		path: '/products',
		name: 'products',
		component: products,
		meta: { title: 'products' }
	},
	{
		path: '/products_xq',
		name: 'products_xq',
		component: products_xq
	},
	
	{
	  path: '/solutions',
	  name: 'solutions',
	  component: solutions,
	  meta: { title: 'solutions' }
	},
	{
	  path: '/solutionsDetail',
	  name: 'solutionsDetail',
	  component: solutionsDetail
	},
	{
	  path: '/news',
	  name: 'news',
	  component: news,
	  meta: { title: 'news' }
	},
	{
	  path: '/newsDetail',
	  name: 'newsDetail',
	  component: newsDetail
	},
	{
	  path: '/contact',
	  name: 'contact',
	  component: contact,
	  meta: { title: 'contact' }
	},
	
	{
	  path: '/about',
	  name: 'about',
	  component: about,
	  meta: { title: 'about' }
	},
	{
		path: '/vrList',
		name: 'vrList',
		component: vrList,
		meta: { title: 'vrList' }
	  },
  ]
  
})
